import CheckboxButton from 'app/components/forms/CheckboxButton';
import Checkmark from 'app/components/svgs/Checkmark';
import { BLUE_F, WHITE_A, RED_G } from 'app/constants/Colors';
import { useCss } from 'app/utils/css';
import React from 'react';
import { inputBaseStyles } from 'app/components/presentation/forms/styles';

interface IProps extends React.ComponentProps<typeof CheckboxButton> {
  error?: boolean;
}

const Checkbox: React.FC<IProps> = ({ checked, error, ...rest }) => {
  const css = useCss();
  const checkboxClass = css('checkbox', {
    ...inputBaseStyles,
    overflow: 'hidden',
    display: 'inline-flex',
    alignItems: 'center',
    width: '14px',
    height: '14px',
    padding: '0',
    marginRight: '0.3em',
    ':active': {
      backgroundColor: WHITE_A,
    },
    borderColor: error ? RED_G : undefined,
  });
  const checkmarkClass = css('checkmark', {
    fill: BLUE_F,
    stroke: 'none',
    flexGrow: 1,
    // If we hide the checkmark by not rendering it, the presence of the
    // checkmark SVG can affect things like the baseline and sizing of the
    // parente elements, causing the position of the checkbox to be different
    // when the box is checked vs. not checked.
    //
    // To avoid this, toggle the checkmark using opacity.
    opacity: checked ? 1 : 0,
  });

  return (
    <CheckboxButton
      {...rest}
      checked={checked}
      className={checkboxClass}
    >
      <Checkmark className={checkmarkClass} />
    </CheckboxButton>
  );
};

export default Checkbox;
